import React from 'react';

export default function Header({ title, left, right }) {
  return (
    <div style={{
      position: 'sticky', top: 0, zIndex: 100,
      padding: '12px 20px',
      paddingTop: 'calc(var(--tg-safe-top, 0px) + 12px)',
      display: 'flex', alignItems: 'center', justifyContent: (left || right) ? 'space-between' : 'center',
      background: 'rgba(13,13,13,0.92)',
      backdropFilter: 'blur(20px)', WebkitBackdropFilter: 'blur(20px)',
      borderBottom: '1px solid var(--border)',
    }}>
      {left || (right && <div style={{ minWidth: 50 }}></div>)}
      <div style={{ fontSize: 18, fontWeight: 700, letterSpacing: -0.3 }}>{title}</div>
      {right || (left && <div style={{ minWidth: 50 }}></div>)}
    </div>
  );
}
